import { render, staticRenderFns } from "./custom-footer-link.vue?vue&type=template&id=88702ca4&"
import script from "./custom-footer-link.vue?vue&type=script&lang=js&"
export * from "./custom-footer-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports